import { useQuery } from 'react-query';
import { getPatientRecommendedChallenges } from '../api/getPatientRecommendedChallenges';

const usePatientRecommendedChallenges = (patientID) => {
  const { data, isLoading, error, refetch } = useQuery(
    ['patient_recommended_challenges', patientID],
    () => getPatientRecommendedChallenges(patientID),
    {
      enabled: !!patientID,
      refetchOnWindowFocus: false,
      staleTime: 50000,
      onError: (error) => {
        console.error('Error fetching patient recommended challenges:', error);
      },
    },
  );

  return {
    data: data || [],
    isLoading,
    error,
    refetch,
    challenges: data || [], // Adding this for consistency with usage in PatientTabChart
  };
};

export default usePatientRecommendedChallenges;
